// extracted by css-extract-rspack-plugin
export default {"warningWrap":"Presenter__warningWrap--hcqsK","warningTitle":"Presenter__warningTitle--K0n0K","warning":"Presenter__warning--YWzoE"};